import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-custom-table-button',
    imports: [CommonModule],
    templateUrl: './custom-table-button.component.html',
    styleUrl: './custom-table-button.component.scss'
})
export class CustomTableButtonComponent {
  @Input() textButton!: string;
  @Input() color!: string;
  @Input() icon!: undefined;
  @Input() hasIcon!: boolean;
  @Input() showButtonText: boolean = false;

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sanitizer: DomSanitizer) {}

  get iconSvg(): SafeHtml {
    const name = this.icon;
    const map: { [k: string]: string } = {
      'x': '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
      'check': '<path d="M20 6 9 17l-5-5"/>',
      'eye': '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
      'send-horizontal': '<path d="m3 3 3 9-3 9 19-9Z"/><path d="M6 12h16"/>',
      'circle-check-big': '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/>',
      'map-pin': '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/>',
    };
    const inner = map[name!] || '';
    if (!inner) return '';
    return this.sanitizer.bypassSecurityTrustHtml(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">' + inner + '</svg>'
    );
  }
}
